import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, TextInput, Label } from "flowbite-react";
import axios from "axios";
import GlobalContext from "../connections/GlobalContext";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { FaEdit, FaTrash } from "react-icons/fa";
import Head_data from "../components/Head_data";
import Button_submit from "../components/Button_submit";
import Return_sales_stock from "./Sales_return";
import { FaArrowLeft, FaPrint } from 'react-icons/fa';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import engineGif from "../image/engine.gif";
import Logo from "../image/logo.jpg";
import CreatableSelect from 'react-select/creatable';




const Sales = ({ theme }) => {
    const { globalValue } = useContext(GlobalContext);
    const [salesData, setSalesData] = useState([]);
    const [spareOptions, setSpareOptions] = useState([]);


    const [currentStep, setCurrentStep] = useState(1);


    const [selectedSpares, setSelectedSpares] = useState([]);
    const [spareId, setSpareId] = useState(null);
    const [quantity, setQuantity] = useState("");
    const [price, setPrice] = useState("");
    const [gst, setGst] = useState("");
    const [brand, setBrand] = useState("");
    const [model, setModel] = useState("");
    const [brands, setBrands] = useState([]);
    const [models, setModels] = useState([]);
    const [temp_quantity, setTemp_quantity] = useState(0);
    const [pdfpopup, setPdfpopup] = useState(false);
    const [pdf_data, setPdf_data] = useState([]);

    const [bill_type, setBill_type] = useState("");
    const [pdf_gst, setPdf_gst] = useState("");
    const [discount, setDiscount] = useState(0);
    const [selectedCustomer, setSelectedCustomer] = useState(null);


    const [name, setName] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [address, setAddress] = useState("");
    const [date, setDate] = useState(() => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    });

    const [today_date, setToday_Date] = useState(() => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    });



    const [loading, setLoading] = useState(false);

    const [modalOpen, setModalOpen] = useState(false);
    const [editingSpareIndex, setEditingSpareIndex] = useState(null);
    const [gst_no, setGst_no] = useState("");
    const [labour_charge, setLabour_charge] = useState(0);



    const [dis, setDis] = useState(true);

    const [customers, setCustomers] = useState([]);

    const [searchTerm, setSearchTerm] = useState("");
    const [filtered, setFiltered] = useState(salesData);
    const [vehicle_no, setVehicle_no] = useState("");
    const [advance, setAdvance] = useState(0);

    const formatDate = (d) => {
        if (!d) return "";
        const dateObj = new Date(d);
        if (isNaN(dateObj)) return "";
        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const year = dateObj.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);


    useEffect(() => {
        const filteredData = (salesData || [])
            .filter((branch) => {
                const name = branch?.name?.toLowerCase() || "";
                const mobile = branch?.mobile_no?.toLowerCase() || "";
                const address = branch?.address?.toLowerCase() || "";
                const vehicle = branch?.vehicle_no?.toLowerCase() || "";
                const date = formatDate(branch?.date);

                const term = searchTerm.toLowerCase();

                return (
                    name.includes(term) ||
                    mobile.includes(term) ||
                    address.includes(term) ||
                    vehicle.includes(term) ||
                    date.includes(term)
                );
            })
        // .sort((a, b) => new Date(b.date) - new Date(a.date));

        setFiltered(filteredData);
    }, [searchTerm, salesData]);


    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${globalValue}/customers`, {
                params: {
                    data: sessionStorage.getItem("branch"),
                    position: "",
                },
                headers: {
                    "x-access-token": sessionStorage.getItem("token"),
                },
            });
            let data = response.data;
            const formattedData = data.map((item) => ({
                value: item[1],
                label: item[2],
                v_no: item[3],
                vehicle_no: item[4],
                advance: item[31] || 0
            }));
            setCustomers(formattedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handlePrint = () => {
        const content = document.getElementById('pdf-content');

        html2canvas(content, { scale: 2 }).then(canvas => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            const pageHeight = pdf.internal.pageSize.getHeight();

            let position = 0;


            pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
            position -= pageHeight;


            while (Math.abs(position) < pdfHeight) {
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
                position -= pageHeight;
            }

            pdf.save('receipt.pdf');
            setDis(true);
        });
    };


    const modelOptions = spareOptions
        .find((s) => s.value === spareId)?.model
        ?.filter((item) => item.brand === brand)
        ?.map((item) => ({
            value: item.model,
            label: item.model,
            data: item
        })) || [];



    const fetchSalesData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${globalValue}/sales`, {
                params: {
                    branch: sessionStorage.getItem("branch"),
                },
                headers: {
                    "x-access-token": sessionStorage.getItem("token"),
                },
            });

            setSalesData(response.data);
        } catch (error) {
            console.error("Error fetching sales data:", error);
        } finally {
            setLoading(false);
        }
    };




    const fetchSpareDetails = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${globalValue}/spareLog`,
                {
                    branch: sessionStorage.getItem("branch"),
                },
                {
                    headers: { "x-access-token": sessionStorage.getItem("token") },
                }
            );

            const options = response.data.map((spare) => ({
                value: spare["spare_id"],
                label: spare["spare_name"],
                model: spare["model"],
                quantity: spare["quantity"],

            }));
            console.log(options)
            setSpareOptions(options);
        } catch (error) {
            console.error("Error fetching spare log:", error);
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSalesData();
        fetchSpareDetails();
        fetchData();

    }, []);

    const options = spareOptions.map(spare => ({
        value: spare.value,
        label: spare.label,
    }));

    const selectedSpare = spareOptions.find((s) => s.value === spareId);

    const brandOptions = selectedSpare?.model
        ?.map((item) => item.brand)
        ?.filter((brand, index, self) => self.indexOf(brand) === index)
        ?.map((brand) => ({
            value: brand,
            label: brand,
        })) || [];



    const handleSpareChange = (selectedOption) => {
        setSpareId(selectedOption.value);
    };


    const [name1, setName1] = useState("");

    const handleAddSpare = () => {
        if (!spareId || !quantity || !price || !gst || !brand || !model) {
            Swal.fire("Warning!", "All fields are mandatory.", "warning");
            return;
        }


        let spareLabel = "";
        for (let i = 0; i < spareOptions.length; i++) {
            let spares = spareOptions[i];
            if (spareId === spares["value"]) {
                spareLabel = spares["label"];
                break;
            }
        }


        const duplicate = selectedSpares.some(
            (item) =>
                String(item.spareId) === String(spareId) &&
                item.brand === brand &&
                item.model === model
        );

        if (duplicate) {
            Swal.fire(
                "Duplicate Entry",
                "This spare with the same brand and model is already added!",
                "warning"
            );
            setSpareId(null);
            setBrand("");
            setModel("");
            return;
        }

        setSelectedSpares([
            ...selectedSpares,
            {
                spareId,
                name1: spareLabel,
                brand: brand,
                model: model,
                quantity: quantity || 0,
                price,
                gst: gst || 0,

            },
        ]);


        setSpareId(null);
        setQuantity("");
        setPrice("");
        setGst("");
        setTemp_quantity("");
        setBrand("");
        setModel("");
    };

    const handleUpdateSpare = () => {
        let updatedSpares = [...selectedSpares];
        updatedSpares[editingSpareIndex] = {
            spareId,
            name1,
            quantity,
            price,
            gst,
            brand,
            model
        };
        setSelectedSpares(updatedSpares);
        setEditingSpareIndex(null);
        setSpareId(null);
        setQuantity("");
        setPrice("");
        setGst("");
        setName1("");
    };
    const handleDeleteSpare = (index) => {
        setSelectedSpares(selectedSpares.filter((_, i) => i !== index));
    };
    const handleSubmit = async () => {
        setLoading(true);
        if (!name || !mobileNo
            || bill_type === "") {
            Swal.fire("Warning!", "All fields are mandatory.", "warning");
            return;
        }
        if (mobileNo.length != 10) {
            Swal.fire("Warning!", "Mobile No should be in 10 digit.", "warning");
            return;
        }
        setLoading(true);
        try {
            const data = {
                name,
                mobile_no: mobileNo,
                address,
                date,
                today_date,
                spares: selectedSpares,
                discount: discount,
                bill_type,
                gst_no,
                labour_charge,
                branch: sessionStorage.getItem("branch"),
                vehicle_no: vehicle_no,
                advance: advance
            };

            const response = await axios.post(`${globalValue}/sales_add`, data, {
                headers: { "x-access-token": sessionStorage.getItem("token") },
            });

            console.log("API Response:", response.data);

            if (response.data === "success") {
                Swal.fire("Success!", `Sale added successfully. Grand Total: ${response.data.grand_total}`, "success");

                setModalOpen(false);
                fetchSalesData();
                clearFields();
            } else {
                Swal.fire("Error!", response.data.message, "error");
            }
        } catch (error) {
            console.error("Error saving sale:", error);
            Swal.fire("Error!", "Something went wrong. Please try again.", "error");
        }
        finally {
            setLoading(false);
        }
    };
    const clearFields = () => {
        setMode("add");
        setName("");
        setMobileNo("");
        setAddress("");
        setDate(new Date().toISOString().split("T")[0]);
        setSelectedSpares([]);
        setSpareId(null);
        setQuantity("");
        setPrice("");
        setGst("");
        setTemp_quantity(0);
        setBill_type("");
        setVehicle_no("");
    };
    const customStyles = {
        table: {
            style: {
                backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
                width: "100%",
                border: theme === "dark" ? "solid 1px rgb(63, 62, 62)" : "solid 1px rgb(226, 232, 240)",
            },
        },
        headCells: {
            style: {
                backgroundColor: theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)",
                color: theme === "dark" ? "white" : "black",
                fontWeight: "bold",
            },
        },
        cells: {
            style: {
                color: theme === "dark" ? "white" : "black",
                backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
                border: theme === "dark" ? "solid 1px rgb(63, 62, 62)" : "solid 1px rgb(255, 255, 255)",
            },
        },
        pagination: {
            style: {
                backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
                color: theme === "dark" ? "white" : "black",
                borderTop: theme === "dark" ? "solid 1px white" : "solid 1px rgb(226, 232, 240)",
            },
            pageButtonsStyle: {
                backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
                color: theme === "dark" ? "white" : "black",
                fill: theme === "dark" ? "white" : "black",
                '&:hover': {
                    backgroundColor: theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)",
                },
            },
        },
    };
    const [temp_spares, setTemp_spares] = useState([]);
    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [temp_id, setTemp_id] = useState("");
    const [temp_spare, setTemp_spare] = useState([]);

    const [name_pdf, setName_pdf] = useState("");
    const [email_pdf, setEmail_pdf] = useState("");
    const [monbile_pdf, setMobile_pdf] = useState("");
    const [spares_pdf, setSpares_pdf] = useState("");
    const [final_total, setFinal_total] = useState("");
    const [date_pdf, setDate_pdf] = useState("");
    const [discount_pdf, setDiscount_pdf] = useState("");


    const [pdf_brand, setPdf_brand] = useState("");
    const [pdf_model, setPdf_model] = useState("");


    const handleUpdate = async () => {
        if (!name || !mobileNo || selectedSpares.length === 0 || bill_type === "") {
            Swal.fire("Warning!", "All fields are mandatory.", "warning");
            return;
        }
        if (mobileNo.length !== 10) {
            Swal.fire("Warning!", "Mobile No should be in 10 digits.", "warning");
            return;
        }

        setLoading(true);
        try {
            const data = {

                name,
                mobile_no: mobileNo,
                address,
                date,
                spares: selectedSpares,
                discount: discount,
                bill_type,
                gst_no,
                labour_charge,
                branch: sessionStorage.getItem("branch"),
                vehicle_no: vehicle_no,
                advance: advance,
                temp_id
            };

            const response = await axios.post(
                `${globalValue}/sales_update`,
                { data }
            );

            console.log("Update API Response:", response.data);

            if (response.data.status === "success") {
                Swal.fire(
                    "Updated!",
                    `Sale updated successfully. Grand Total: ${response.data.grand_total}`,
                    "success"
                );

                setModalOpen(false);
                fetchSalesData();
                clearFields();
            } else {
                Swal.fire("Error!", response.data.message || "Update failed", "error");
            }
        } catch (error) {
            console.error("Error updating sale:", error);
            Swal.fire("Error!", "Something went wrong while updating. Please try again.", "error");
        } finally {
            setLoading(false);
        }
    };

    const [mode, setMode] = useState("add");



    const handleEditBranch = (row) => {
        setModalOpen(true);
        setMode("edit");
        setCurrentStep(2);

        setTemp_id(row.id);
        setName(row.name || "");

        setSelectedCustomer({
            label: `${row.name}${row.vehicle_no ? ` (${row.vehicle_no})` : ""}`,
            value: row.name,
            v_no: row.mobile_no || "",
            name: row.name || "",
            vehicle_no: row.vehicle_no || ""
        });

        setMobileNo(row.mobile_no || "");
        setAddress(row.address || "");

        const formattedDate = row.date
            ? new Date(row.date).toISOString().split("T")[0]
            : new Date().toISOString().split("T")[0];
        setDate(formattedDate);

        setDiscount(row.discount || 0);
        setBill_type(row.bill_type || "");
        setGst_no(row.gst_no || "");
        setAdvance(row.advance || 0);
        setLabour_charge(row.labour_charge || "");
        setSelectedSpares(row.spares || []);
        setSpareId(null);
        setQuantity("");
        setPrice("");
        setGst("");
        setBrand("");
        setModel("");
        setTemp_quantity(0);
        setVehicle_no(row.vehicle_no || "");
    };

    useEffect(() => {
        setResetPaginationToggle(prev => !prev);
    }, [filtered]);


    const columns = [
        {
            name: "S.No",
            cell: (row, index) => (currentPage - 1) * perPage + index + 1,
            width: "70px",
        },
        {
            name: "Date",
            selector: (row) =>
                new Date(row.date).toLocaleDateString("en-GB"),
            sortable: true,
        },
        {
            name: "Customer Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Vehicle No",
            selector: (row) => row.vehicle_no,
            sortable: true,
        },
        {
            name: "Mobile/Whatsapp No",
            selector: (row) => row.mobile_no,
        },
        {
            name: "Email Id",
            selector: (row) => row.address,
        },
        {
            name: "Total Spares",
            selector: (row) => row.spares.length,
        },
        {
            name: "Action",
            width: "300px",
            selector: (row) => (
                <div className="w-full flex justify-center gap-2">
                    <button
                        className="p-2 text-white bg-blue-700 hover:bg-blue-800 rounded-md shadow-xl"
                        onClick={() => {
                            setTemp_spares(row.spares);
                            setShow(true);
                        }}
                    >
                        <i className="fa fa-eye"></i>
                    </button>

                    <button
                        className="p-2 text-white bg-yellow-500 hover:bg-yellow-800 rounded-md shadow-xl"
                        onClick={() => {
                            setTemp_id(row.id);
                            setTemp_spare(row.spares);
                            setShow2(true);
                        }}
                    >
                        Return
                    </button>

                    {row.status !== 1 && (
                        <button
                            onClick={() => handleEditBranch(row)}
                            className="p-2 text-white bg-blue-700 hover:bg-blue-800 rounded-md shadow-xl"
                        >
                            <i className="fa fa-edit"></i>
                        </button>
                    )}

                    {row.status !== 1 && (
                        <button
                            onClick={async () => {
                                const result = await Swal.fire({
                                    title: "Are you sure?",
                                    text: "Do you want to complete this sale?",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonText: "Yes, complete it!",
                                });

                                if (result.isConfirmed) {
                                    try {
                                        const response = await axios.post(
                                            `${globalValue}/complete_sales`,
                                            { id: row.id }
                                        );

                                        if (response.data === "success") {
                                            Swal.fire(
                                                "Completed!",
                                                "Sale completed successfully.",
                                                "success"
                                            );
                                            fetchSalesData();
                                        } else {
                                            Swal.fire(
                                                "Error!",
                                                "Something went wrong.",
                                                "error"
                                            );
                                        }
                                    } catch {
                                        Swal.fire(
                                            "Error!",
                                            "API call failed.",
                                            "error"
                                        );
                                    }
                                }
                            }}
                            className="p-2 text-white bg-green-700 hover:bg-green-800 rounded-md shadow-xl"
                        >
                            Complete
                        </button>
                    )}

                    <button
                        className="bg-blue-500 text-white p-2 rounded-md shadow-md hover:bg-blue-600"
                        onClick={() => {
                            setPdfpopup(true);
                            setName_pdf(row.name);
                            setMobile_pdf(row.mobile_no);
                            setEmail_pdf(row.address);
                            setSpares_pdf(row.spares);
                            setFinal_total(row.grand_total);
                            setDate_pdf(row.date);
                            setLabour_charge(row.labour_charge);
                            setPdf_gst(row.gst_no);
                            setPdf_brand(row.brand);
                            setPdf_model(row.model);
                            setDiscount_pdf(row.discount || 0);
                            setVehicle_no(row.vehicle_no || "");
                        }}
                    >
                        <FaPrint />
                    </button>
                </div>
            ),
        },
    ];





    return (
        <div
            className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] mt-16 h-[92vh] flex justify-center items-center box-border ${theme === "dark" ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-800"
                }`}
        >
            {loading && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
                    <img src={engineGif} alt="Loading..." className="w-24 h-24" />
                </div>
            )}
            <div
                className={`w-[95%] md:w-[98%] h-[95%] px-4 py-2 rounded-xl shadow-xl overflow-auto ${theme === "dark" ? "bg-gray-800 text-gray-200" : "bg-white text-gray-800"
                    }`}
            >
                <div className="w-full flex justify-between text-gray-600">
                    {show2 && <button onClick={() => { setShow2(false); }} className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded hover:bg-gray-300">
                        <FaArrowLeft className="w-4 h-4" />
                    </button>}
                    <Head_data data="Sales Report" font="" size="3xl" color={theme === "dark" ? "text-gray-200" : "text-gray-800"}></Head_data>
                    {!show2 && <Button onClick={() => { setModalOpen(true); clearFields(); }}>Sale Product</Button>}
                </div>
                <div className="py-6 md:px-2">



                    {!show2 ? <>
                        <input
                            type="text"
                            placeholder="Search by name,vehicle no,date,mobile_no"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full md:w-1/3 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                        />
                        <DataTable
                            columns={columns}
                            data={filtered}
                            pagination
                            paginationPerPage={perPage}
                            paginationResetDefaultPage={resetPaginationToggle}
                            onChangePage={(page) => setCurrentPage(page)}
                            onChangeRowsPerPage={(rows, page) => {
                                setPerPage(rows);
                                setCurrentPage(page);
                            }}
                            customStyles={customStyles}
                            highlightOnHover
                            striped={theme !== "dark"}
                            responsive
                        />

                    </> : <Return_sales_stock id={temp_id} spare={temp_spare} fetchSalesData={fetchSalesData} show2={setShow2} />}

                </div>
            </div>

            <Modal show={pdfpopup} size="6xl" popup={true} onClose={() => {
                setPdfpopup(false);
                setPdf_gst("");
                setPdf_brand("");
                setPdf_model("");
            }}>
                <Modal.Header className="bg-white text-gray-900 border-b border-gray-200"></Modal.Header>
                <Modal.Body className="flowbite-modal-b">
                    <div id="pdf-content" className="border border-gray-500 mx-2 bg-white p-6 text-gray-800">

                        <div className="flex items-center mb-4">
                            <div className="">
                                <img
                                    src={Logo}
                                    alt="JALS Automobiles Logo"
                                    className="h-16 w-auto"
                                />
                            </div>

                            <div className="flex-1 text-center">
                <h2 className="text-2xl font-bold uppercase">
                  JALS AUTOMOBILES
                </h2>

                {sessionStorage.getItem("branch") === "JBRANCH2025030" ? (
                  <>
                    <p>
                      Door No : 6/63, Jals Road, Kuppottu Vilai,
                      <br />
                      Kadamacode, Melpuram, Pacode Post - 629168
                    </p>
                    <p>Ph : 04651-264007 | Mob : 8300451644</p>
                    <p>GSTIN : 33AMEPL9265E1Z1</p>
                  </>
                ) : (
                  <>
                    <p>
                      6/31 F, Karavilagam Road, Chennithottam Junction, Vettuvanni,
                      <br />
                      Marthandam - 629162
                    </p>
                    <p>Ph: 04651-271220 | Mob: 9488495820</p>
                    <p>GSTIN: 33AMEPL9265E1Z1</p>
                  </>
                )}
              </div>

                        </div>


                        <div className="flex justify-between items-center border-b border-gray-500 pb-2">
                            <h3 className="text-lg font-bold">SALES BILL</h3>
                            <div className="text-right">

                                <p>Date: <span className="font-semibold">{new Date(date_pdf).toLocaleDateString('en-GB')}</span></p>
                            </div>
                        </div>


                        <div className="border border-gray-400 p-4 mt-4 mb-4">
                            <p><strong>To:</strong> {pdf_data?.customer_name}</p>
                            <p>Name: {name_pdf} {pdf_brand} {pdf_model}</p>
                            <p>Vehicle No: {vehicle_no}</p>
                            <p>whatsapp/Mobile No: {monbile_pdf}</p>
                            <p>Email: {email_pdf}</p>
                            {pdf_gst && <p>GST No: {pdf_gst}</p>}
                        </div>



                        {Array.isArray(spares_pdf) && spares_pdf.length > 0 ? (

                            <table className="w-full border border-gray-300 mt-1">
                                <thead>
                                    <tr className="bg-gray-200">
                                        <th className="border border-gray-300 p-3 w-[5%] text-left">Sno</th>
                                        <th className="border border-gray-300 p-3 w-[20%] text-left">Spare Name</th>
                                        <th className="border border-gray-300 p-3 w-[10%] text-center">Quantity</th>
                                        <th className="border border-gray-300 p-3 w-[10%] text-right">Price</th>
                                        <th className="border border-gray-300 p-3 w-[10%] text-right">CGST</th>
                                        <th className="border border-gray-300 p-3 w-[10%] text-right">SGST</th>
                                        <th className="border border-gray-300 p-3 w-[10%] text-right">Price with GST</th>
                                        <th className="border border-gray-300 p-3 w-[10%] text-right">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {spares_pdf.map((item, index) => {
                                        const gstRate = parseFloat(item.gst) || 0;
                                        const priceWithGST = parseFloat(item.price) || 0;
                                        const quantity = parseFloat(item.quantity) || 0;

                                        const priceWithoutGST = priceWithGST / (1 + gstRate / 100);
                                        const total = priceWithGST * quantity;

                                        return (
                                            <tr key={index}>
                                                <td className="border border-gray-300 p-3 text-center">{index + 1}</td>
                                                <td className="border border-gray-300 p-3">{item.name1}</td>
                                                <td className="border border-gray-300 p-3 text-center">{quantity.toFixed(2)}</td>
                                                <td className="border border-gray-300 p-3 text-right">₹{priceWithoutGST.toFixed(2)}</td>
                                                <td className="border border-gray-300 p-3 text-right">{(gstRate / 2).toFixed(1)}%</td>
                                                <td className="border border-gray-300 p-3 text-right">{(gstRate / 2).toFixed(1)}%</td>
                                                <td className="border border-gray-300 p-3 text-right">₹{priceWithGST.toFixed(2)}</td>
                                                <td className="border border-gray-300 p-3 text-right">₹{total.toFixed(2)}</td>
                                            </tr>
                                        );
                                    })}

                                    {/* Totals */}
                                    <tr className="bg-gray-100 font-bold">
                                        <td colSpan="7" className="border border-gray-300 p-3 text-right">
                                            Grand Total:
                                        </td>
                                        <td className="border border-gray-300 p-3 text-right text-red-600">
                                            ₹{spares_pdf.reduce((sum, item) => {
                                                const price = parseFloat(item.price) || 0;
                                                const qty = parseFloat(item.quantity) || 0;
                                                return sum + price * qty;
                                            }, 0).toFixed(2)}
                                        </td>
                                    </tr>

                                    <tr className="bg-gray-100 font-bold">
                                        <td colSpan="7" className="border border-gray-300 p-3 text-right">
                                            Labour Charge:
                                        </td>
                                        <td className="border border-gray-300 p-3 text-right text-gray-600">
                                            ₹{Number(labour_charge || 0).toFixed(2)}
                                        </td>
                                    </tr>

                                    <tr className="bg-gray-100 font-bold">
                                        <td colSpan="7" className="border border-gray-300 p-3 text-right">
                                            Discount:
                                        </td>
                                        <td className="border border-gray-300 p-3 text-right text-blue-600">
                                            -₹{parseFloat(discount_pdf || 0).toFixed(2)}
                                        </td>
                                    </tr>

                                    <tr className="bg-gray-100 font-bold">
                                        <td colSpan="7" className="border border-gray-300 p-3 text-right">
                                            Total Payable Amount:
                                        </td>
                                        <td className="border border-gray-300 p-3 text-right text-green-600">
                                            ₹{(
                                                spares_pdf.reduce((sum, item) => {
                                                    const price = parseFloat(item.price) || 0;
                                                    const qty = parseFloat(item.quantity) || 0;
                                                    return sum + price * qty;
                                                }, 0) +
                                                Number(labour_charge || 0) -
                                                Number(discount_pdf || 0)
                                            ).toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        ) : labour_charge > 0 ? (

                            <table className="w-full border border-gray-300 mt-1">
                                <thead>
                                    <tr className="bg-gray-200">
                                        <th className="border border-gray-300 p-3 w-[80%] text-left">Description</th>
                                        <th className="border border-gray-300 p-3 w-[20%] text-right">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="border border-gray-300 p-3 font-bold">Labour Charge</td>
                                        <td className="border border-gray-300 p-3 text-right">₹{Number(labour_charge).toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-300 p-3 font-bold">Discount</td>
                                        <td className="border border-gray-300 p-3 text-right text-blue-600">
                                            -₹{Number(discount_pdf || 0).toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr className="bg-gray-100 font-bold">
                                        <td className="border border-gray-300 p-3 text-right">Total Payable</td>
                                        <td className="border border-gray-300 p-3 text-right text-green-600">
                                            ₹{(Number(labour_charge || 0) - Number(discount_pdf || 0)).toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        ) : (

                            <p className="text-center text-gray-500">No spare or labour data available.</p>
                        )}



                        <div className="mt-6 flex justify-between">
                            <div>
                                <p className="font-bold">For JALS AUTOMOBILES</p>
                            </div>
                            <div className="text-right">
                                <p className="font-bold">Authorized Signatory</p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="flowbite-modal-b">
                    <button
                        onClick={() => handlePrint()}
                        className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                    >
                        Print
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={show} onClose={() => setShow(false)} size="2xl">
                <Modal.Header className="text-lg font-semibold flowbite-modal-h">
                    Spare Details
                </Modal.Header>

                <Modal.Body className="max-h-[400px] overflow-auto flowbite-modal-h" >
                    {temp_spares.length > 0 ? (
                        <div className="overflow-x-auto">
                            <table className="w-full table-auto border border-gray-300">
                                <thead className="bg-gray-200">
                                    <tr>
                                        <th className="px-4 py-2 border">Spare Name</th>
                                        <th className="px-4 py-2 border">Brand</th>
                                        <th className="px-4 py-2 border">Model</th>
                                        <th className="px-4 py-2 border">Quantity</th>
                                        <th className="px-4 py-2 border">Price</th>
                                        {/* <th className="px-4 py-2 border">GST (%)</th> */}
                                        <th className="px-4 py-2 border">Total (₹)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {temp_spares.map((spare, index) => {
                                        const totalPrice = spare.quantity * spare.price;
                                        const gstAmount = 0;
                                        const totalWithGST = totalPrice + gstAmount;

                                        return (
                                            <tr key={index} className="border-b hover:bg-gray-100">
                                                <td className="px-4 py-2 border text-center">{spare.name1}</td>
                                                <td className="px-4 py-2 border text-center">{spare.brand}</td>
                                                <td className="px-4 py-2 border text-center">{spare.model}</td>
                                                <td className="px-4 py-2 border text-center">{spare.quantity}</td>
                                                <td className="px-4 py-2 border text-center">₹{spare.price}</td>
                                                {/* <td className="px-4 py-2 border text-center">{spare.gst}%</td> */}
                                                <td className="px-4 py-2 border text-center">₹{totalWithGST.toFixed(2)}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot className="bg-gray-100 font-semibold">
                                    <tr>
                                        <td colSpan="5" className="px-4 py-2 border text-right">Grand Total:</td>
                                        <td className="px-4 py-2 border text-center">
                                            ₹{temp_spares.reduce((acc, spare) => {
                                                const totalPrice = spare.quantity * spare.price;
                                                const gstAmount = (spare.gst / 100) * totalPrice;
                                                return acc + (totalPrice + gstAmount);
                                            }, 0).toFixed(2)}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    ) : (
                        <p className="text-center text-gray-500">No spare details available</p>
                    )}
                </Modal.Body>
            </Modal>





            <Modal show={modalOpen} onClose={() => setModalOpen(false)} size="8xl">
                <Modal.Header className="flowbite-modal-h">{currentStep === 1 ? "Spare Details" : "Customer Details"}</Modal.Header>
                <Modal.Body className="flowbite-modal-h">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                        <div className="space-y-4">
                            {currentStep === 1 ? (
                                <>
                                    <Label>Select Spare</Label>
                                    {editingSpareIndex === null || spareOptions.length > 0 ? (


                                        <Select
                                            value={options.find(option => option.value === spareId) || null}
                                            onChange={(selectedOption) => setSpareId(selectedOption?.value)}
                                            options={options}
                                            placeholder="Select Spare"
                                            isSearchable
                                            className="w-full"
                                            classNamePrefix="react-select"
                                        />



                                    ) : null}



                                    <>

                                        <Label className="block text-gray-700 text-sm font-medium mb-1">Select Brand</Label>


                                        <Select
                                            value={brandOptions.find((option) => option.value === brand) || null}
                                            onChange={(selectedOption) => setBrand(selectedOption?.value)}
                                            options={brandOptions}
                                            placeholder="Select Brand"
                                            isSearchable
                                            className="w-full"
                                            classNamePrefix="react-select"
                                        />
                                    </>

                                    <>

                                        <Label className="block text-gray-700 text-sm font-medium mb-1">Select Model</Label>


                                        <Select
                                            value={modelOptions.find(option => option.value === model) || null}
                                            onChange={(selectedOption) => {
                                                setModel(selectedOption?.value || "");

                                                if (selectedOption?.data) {
                                                    setTemp_quantity(selectedOption.data.quantity);
                                                    setPrice(selectedOption.data.mrp);
                                                    setGst(selectedOption.data.gst);
                                                }
                                            }}
                                            options={modelOptions}
                                            placeholder="Select Model"
                                            isSearchable
                                            className="w-full"
                                            classNamePrefix="react-select"
                                        />

                                        <p>Available Quantity: {temp_quantity}</p>
                                    </>




                                    <Label>Quantity</Label>
                                    <TextInput
                                        value={quantity}
                                        onChange={(e) => {
                                            const val = e.target.value;

                                            // Allow empty or decimal values
                                            if (val === "" || /^(\d+(\.\d*)?)?$/.test(val)) {
                                                const enteredValue = val === "" ? "" : parseFloat(val);

                                                if (enteredValue === "" || (!isNaN(enteredValue) && enteredValue <= temp_quantity)) {
                                                    setQuantity(val);
                                                } else {
                                                    Swal.fire({
                                                        icon: "warning",
                                                        title: "Quantity Exceeded!",
                                                        text: `Only ${temp_quantity} items available.`,
                                                        confirmButtonColor: "#d33",
                                                    });
                                                }
                                            }
                                        }}
                                        placeholder="Quantity"
                                    />





                                    <Label>Price</Label>
                                    <TextInput
                                        value={price}
                                        onChange={(e) => setPrice(e.target.value)}
                                        placeholder="Price"
                                        disabled
                                    />

                                    <Label>GST %</Label>
                                    <TextInput
                                        value={gst}
                                        onChange={(e) => setGst(e.target.value)}
                                        placeholder="GST %"
                                        disabled
                                    />





                                    <div className="flex gap-4">
                                        <Button
                                            className="bg-blue-500  px-3 py-1 rounded-md shadow-md"
                                            onClick={editingSpareIndex !== null ? handleUpdateSpare : handleAddSpare}
                                        >
                                            {editingSpareIndex !== null ? "Update Spare" : "Add Spare"}
                                        </Button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <Label>Customer Name</Label>
                                    <CreatableSelect
                                        options={customers.map(cust => ({
                                            label: `${cust.label} (${cust.vehicle_no})`,
                                            value: cust.value,
                                            v_no: cust.v_no,
                                            name: cust.label,
                                            vehicle_no: cust.vehicle_no,
                                            advance: cust.advance
                                        }))}

                                        isSearchable
                                        value={selectedCustomer}

                                        onChange={(selected) => {
                                            if (selected) {
                                                setSelectedCustomer(selected);
                                                setName(selected?.name || "");
                                                setMobileNo(selected?.v_no || "");
                                                setVehicle_no(selected?.vehicle_no || "");
                                                setAdvance(selected?.advance || "");
                                            } else {
                                                setSelectedCustomer(null);
                                                setName("");
                                                setMobileNo("");
                                                setVehicle_no("");
                                            }
                                        }}

                                        onCreateOption={(inputValue) => {
                                            const newOption = {
                                                label: inputValue,
                                                value: inputValue,
                                                v_no: "",
                                                name: inputValue,
                                                vehicle_no: "",
                                            };
                                            setSelectedCustomer(newOption);
                                            setName(inputValue);
                                            setMobileNo("");
                                            setVehicle_no("");
                                        }}

                                        getOptionLabel={(option) => option.vehicle_no ? `${option.name} (${option.vehicle_no})` : option.name}
                                        getOptionValue={(option) => option.value}
                                        placeholder="Search for a customer..."
                                    />

                                    <Label>Vehicle NO</Label>
                                    <TextInput
                                        value={vehicle_no}
                                        onChange={(e) => setVehicle_no(e.target.value)}
                                        placeholder="Vehicle No"
                                        color="white"

                                    />

                                    <Label>Date</Label>
                                    <TextInput
                                        value={date}
                                        onChange={(e) => setDate(e.target.value)}
                                        placeholder="Date"
                                        color="white"
                                        type="date"
                                        disabled={sessionStorage.getItem("position") !== "superadmin"}
                                    />


                                    <Label>Mobile/whatsapp No</Label>
                                    <TextInput
                                        value={mobileNo}
                                        onChange={(e) => {
                                            const validMobile = e.target.value.replace(/\D/g, "");
                                            if (validMobile.length <= 10) {
                                                setMobileNo(validMobile);
                                            }
                                        }}
                                        placeholder="Mobile No"
                                        color={mobileNo.length != 10 && mobileNo != "" ? "failure" : "white"}
                                        helperText={mobileNo.length != 10 && mobileNo != "" ? "Mobile number should be in 10 digit!" : ""}
                                    />


                                    <Label>Email Id</Label>
                                    <TextInput
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        placeholder="email id"
                                        color="white"

                                    />


                                    <Label>Discount</Label>
                                    <TextInput
                                        value={discount}

                                        disabled={mode === "edit"}
                                        onChange={(e) => {
                                            const enteredDiscount = parseFloat(e.target.value) || 0;


                                            const subtotal = selectedSpares.reduce((acc, spare) => {
                                                const itemTotal = spare.price * spare.quantity;
                                                const gstAmount = 0;
                                                return acc + itemTotal + gstAmount;
                                            }, 0);

                                            const labour = parseFloat(labour_charge) || 0;
                                            const totalBeforeDiscount = subtotal + labour;


                                            if (enteredDiscount > totalBeforeDiscount) {
                                                Swal.fire({
                                                    icon: "warning",
                                                    title: "Invalid Discount",
                                                    text: "Discount cannot be greater than the total amount!",
                                                    confirmButtonColor: "#3085d6",
                                                });
                                                return;
                                            }

                                            setDiscount(e.target.value);
                                        }}
                                        placeholder="Discount"
                                    />

                                    <Label>Bill Type</Label>
                                    <select
                                        value={bill_type}
                                        onChange={(e) => setBill_type(e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    >
                                        <option value="">Select Bill Type</option>
                                        <option value="cash">Cash</option>
                                        <option value="credit">Credit</option>
                                    </select>
                                    <Label>Gst No</Label>
                                    <TextInput
                                        value={gst_no}
                                        onChange={(e) => setGst_no(e.target.value)}
                                        placeholder="Gst No"
                                        color="white"

                                    />

                                    <Label>Labour Charge</Label>
                                    <TextInput
                                        value={labour_charge}
                                        onChange={(e) => setLabour_charge(e.target.value)}
                                        placeholder="labour charge"
                                        color="white"

                                    />
                                    <Label>Advance Amount</Label>
                                    <TextInput
                                        value={advance}
                                        disabled={mode === "edit"}
                                        onChange={(e) => {
                                            const enteredAdvance = parseFloat(e.target.value) || 0;
                                            const subtotal = selectedSpares.reduce((acc, spare) => {
                                                const itemTotal = spare.price * spare.quantity;
                                                const gstAmount = 0;
                                                return acc + itemTotal + gstAmount;
                                            }, 0);
                                            const labour = parseFloat(labour_charge) || 0;
                                            const discountValue = parseFloat(discount) || 0;
                                            const grandTotal = subtotal + labour - discountValue;

                                            if (grandTotal > 0 && enteredAdvance > grandTotal) {
                                                Swal.fire({
                                                    icon: "warning",
                                                    title: "Invalid Advance Amount",
                                                    text: "Advance amount cannot be greater than the total payable!",
                                                    confirmButtonColor: "#3085d6",
                                                });
                                                return;
                                            }

                                            setAdvance(e.target.value);
                                        }}
                                        placeholder="Advance Amount"
                                        color="white"
                                        type="number"
                                    />

                                </>
                            )}
                        </div>


                        <div className="overflow-auto">
                            <table className="w-full border border-gray-300 min-w-[500px] border-collapse">
                                <thead className="bg-gray-200 text-gray-700 uppercase text-sm">
                                    <tr>
                                        <th className="px-4 py-2 border">Spare</th>
                                        <th className="px-4 py-2 border">Brand</th>
                                        <th className="px-4 py-2 border">Model</th>
                                        <th className="px-4 py-2 border">Qty</th>
                                        <th className="px-4 py-2 border">GST (%)</th>
                                        <th className="px-4 py-2 border">Price</th>
                                        <th className="px-4 py-2 border">Total</th>
                                        <th className="px-4 py-2 border">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-800 text-sm">
                                    {selectedSpares.map((spare, index) => (
                                        <tr key={index} className="border-b py-4 hover:bg-gray-100 transition-all">
                                            <td className="text-center px-4 py-2 border">{spare.name1}</td>
                                            <td className="text-center px-4 py-2 border">{spare.brand}</td>
                                            <td className="text-center px-4 py-2 border">{spare.model}</td>
                                            <td className="text-center px-4 py-2 border">{spare.quantity}</td>
                                            <td className="text-center px-4 py-2 border">{spare.gst}%</td>
                                            <td className="text-center px-4 py-2 border">₹{spare.price}</td>
                                            <td className="text-center px-4 py-2 border">₹{spare.price * spare.quantity}</td>

                                            <td className="text-center px-4 py-2 h-full  flex justify-center item center  gap-3">

                                                <button className="text-red-500 hover:text-red-600 transition" onClick={() => handleDeleteSpare(index)}>
                                                    <FaTrash className="text-lg" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}

                                    <tr>
                                        <td colSpan="6" className="text-right px-4 py-2 border">Labour Charge:</td>
                                        <td className="text-center px-4 py-2 border text-green-600 font-bold">
                                            ₹{labour_charge}/-
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="6" className="text-right px-4 py-2 border">Discount:</td>
                                        <td className="text-center px-4 py-2 border text-green-600 font-bold">
                                            - {discount}/-
                                        </td>
                                    </tr>

                                    <tr className="font-semibold bg-gray-100 text-gray-900">
                                        <td colSpan="6" className="text-right px-4 py-2 border">Grand Total:</td>
                                        <td className="text-center px-4 py-2 border text-green-600 font-bold">
                                            ₹{
                                                (
                                                    selectedSpares.reduce((acc, spare) => {
                                                        const itemTotal = spare.price * spare.quantity;
                                                        const gstAmount = 0;
                                                        return acc + itemTotal + gstAmount;
                                                    }, 0)
                                                    + (parseFloat(labour_charge) || 0)
                                                    - (parseFloat(discount) || 0)
                                                ).toFixed(2)
                                            }/-
                                        </td>



                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className="flowbite-modal-h">
                    {currentStep === 2 && <button className="bg-gray-200 border border-gray-400 rounded-md shadow-md px-4 py-2" onClick={() => setCurrentStep(1)}>Back</button>}
                    {currentStep === 1 ? <Button_submit onClick={() => setCurrentStep(2)}
                        data="Continue"
                        type="submit"
                        aditional="ms-auto"

                    ></Button_submit> : <Button_submit

                        onClick={mode === "add" ? handleSubmit : handleUpdate}

                        data={mode === "add" ? "Add Sale" : "Update Sale"}
                        type="submit"
                        aditional="ms-auto"

                    ></Button_submit>}
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Sales;
